import styled from 'styled-components'

export const SummaryHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px 0;
`

export const SummaryTitle = styled.div`
  font-weight: bold;
`

export const CompetenciesSubtitle = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0;
`

export const HorizontalDivider = styled.div`
  height: 1px;
  background-color: #1f2124;
  width: 100%;
  margin: 10px 0 30px;
`

export const CompetencyCard = styled.div`
  padding: 20px;
  margin-bottom: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
`

export const CompetencyHeader = styled.div`
  display: flex;
  align-items: baseline;
  margin: 0 0 8px;
`

export const CompetencyNumber = styled.p`
  margin: 0 10px 0 0;
  font-weight: 600;
  width: 30px;
  font-size: 16px;
`

export const CompetencyTitle = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: 16px;
  color: #1f2124;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  flex: 1;
`

export const CompetencyDescription = styled.p`
  margin: 0 0 15px 40px;
  color: #1f2124;
  font-size: 16px;
  font-weight: 400;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  max-width: calc(100% - 40px);
`

export const QuestionsList = styled.div`
  margin-left: 40px;
`

export const QuestionItem = styled.div`
  margin: 8px 0;
`

export const QuestionText = styled.p`
  margin: 0;
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  font-weight: 400;
  color: #1f2124;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
`

export const QuestionNumber = styled.span`
  margin-right: 10px;
  min-width: 24px;
  font-weight: 500;
  flex-shrink: 0;
`

export const ActionButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  padding: 10px 20px 10px 0;
`

export const EditButton = styled.button`
  background-color: transparent;
  color: #2d749c;
  margin-right: 15px;
  display: flex;
  align-items: center;
  box-shadow: none;
  padding: 5px 10px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;

  &:hover {
    opacity: 0.8;
  }
`

export const DeleteButton = styled.button`
  background-color: transparent;
  color: #ff6b6b;
  display: flex;
  align-items: center;
  box-shadow: none;
  padding: 5px 10px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;

  &:hover {
    opacity: 0.8;
  }
`

export const IconWrapper = styled.span`
  margin-right: 5px;
  display: flex;
  align-items: center;

  svg,
  img {
    width: 20px;
    height: 20px;
  }
`

export const NewCompetencyButton = styled.button`
  width: fit-content;
  padding: 8px 16px;
  border: 1px solid #2d749c;
  border-radius: 4px;
  color: #2d749c;
  background-color: transparent;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
